import * as React from 'react';
import { ISelectOption } from '../../../../data/types';
import { Select } from '../Select';

interface IProps {
  value: ISelectOption;
  disabled?: boolean;
  onChange: (s: ISelectOption) => void;
}

const SecondFactorSelect = (props: IProps): React.ReactElement => {
  const options: ISelectOption[] = [
    { label: 'SMS', value: 'sms' },
    { label: 'Authenticator App', value: 'totp' },
  ];

  return (
    <Select
      options={options}
      value={props.value}
      isDisabled={props.disabled}
      placeholder='Second Factor Type...'
      onChange={props.onChange}
      id={'input-select'}
      cache
    />
  );
};

export { SecondFactorSelect };
